import { Page, Text } from '@zillow/constellation-10';
import { ErrorPage as ErrorPageComponent } from '@zg-rentals/error-page-components';

const CONTENT = {
  HEADER_TITLE: 'Your rental',
  DETAILS: 'Try refreshing the page or come back later.',
} as const;

const ErrorPage = () => {
  return (
    <>
      <Page.Header>
        <Text
          css={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            textStyle: { base: 'heading-md', lg: 'heading-lg' },
          }}
        >
          {CONTENT.HEADER_TITLE}
        </Text>
      </Page.Header>
      <Page.Content>
        <ErrorPageComponent errorDetails={CONTENT.DETAILS} />
      </Page.Content>
    </>
  );
};

export default ErrorPage;
